import { DomainSheet } from "@/components/domain";
import { createFileRoute, useNavigate } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/(service-providers)/service-providers/$id/_sheet"
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();
  const { domain } = Route.useSearch();
  const navigate = useNavigate();
  return (
    <DomainSheet
      onClose={() =>
        navigate({
          to: "/service-providers/$id",
          params: { id },
          search: { domain },
        })
      }
    />
  );
}
